import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=a146b518&scoped=true"
import script from "./login2.vue?vue&type=script&lang=js"
export * from "./login2.vue?vue&type=script&lang=js"
import style0 from "./login2.vue?vue&type=style&index=0&id=a146b518&prod&lang=less&scoped=true"
import style1 from "./login2.vue?vue&type=style&index=1&id=a146b518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a146b518",
  null
  
)

export default component.exports